module.exports = "/_next/static/images/cccedcba656441f06b42b5591ff3ebde-rewards-home-card@3x.png.webp";